import primaryComponents from "../../../primaryComponents";
import { ArrowRight } from "../../../../assets/svgIcons";
// import styles from "./styles.module.scss";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import useValidation from "./useValidation";
import { useSmsCampaignScheduleForm } from "./useSmsCampaignScheduleForm";
import styles from "./styles.module.scss";
import { capitalizeLetter } from "../../../../helpers";
import { useEffect } from "react";

export const SmsCampaignScheduleForm = ({ smsCampaign = {} }) => {
  const { isSubmiting, formData, days, setFormData, handleSubmitSchedule } =
    useSmsCampaignScheduleForm({ smsCampaign });

  const {
    control,
    formState: { errors },
    handleSubmit,
    trigger,
    setValue,
  } = useValidation({ ...formData });

  useEffect(() => {
    setValue("delivery_type", formData?.delivery_type);
  }, [formData?.delivery_type]);

  return (
    <>
      <div className={"d-flex flex-column"} style={{ gap: "25px" }}>
        <div>
          <h5>Schedule Delivery</h5>
          <p>Configure exactly when your audience receives this campaign</p>
        </div>

        <div
          className={`${globalStyles["cardWithBackground"]} white p-0`}
          style={{ gap: "15px" }}
        >
          <primaryComponents.BoxedRadioInput
            classNames="p-4"
            style={{ alignItems: "start" }}
            name="deliveryType"
            id="deliveryTypeImmediately"
            isChecked={formData?.delivery_type === "IMMEDIATE"}
            setRadioValue={() => {
              setFormData((prev) => ({
                ...prev,
                delivery_type: "IMMEDIATE",
              }));
            }}
          >
            <div className="ml-2">
              <h6>Send Immediately</h6>
              <p>
                Your campaign will be queued for delivery immediately after you
                click the schedule button
              </p>
            </div>
          </primaryComponents.BoxedRadioInput>

          <primaryComponents.BoxedRadioInput
            classNames="p-4"
            contentStyle={{
              width: "100%",
              display: "block",
              cursor: "default",
            }}
            style={{ alignItems: "start" }}
            name="deliveryType"
            id="deliveryTypeSchedule"
            isChecked={
              formData?.delivery_type === "SCHEDULED_ONCE" ||
              formData?.delivery_type === "RECURRING"
            }
            setRadioValue={() => {
              setFormData((prev) => ({
                ...prev,
                delivery_type:
                  formData?.delivery_type === "IMMEDIATE"
                    ? "SCHEDULED_ONCE"
                    : formData?.delivery_type,
              }));
            }}
          >
            <div className="d-flex flex-column ml-2" style={{ gap: "15px" }}>
              <label htmlFor="deliveryTypeSchedule" className="cursor-pointer">
                <h6>Schedule for specific date and time</h6>
                <p>Choose exactly when you want your campaign to launch</p>
              </label>

              {formData?.delivery_type !== "IMMEDIATE" ? (
                <>
                  <hr />

                  <div
                    className="d-flex flex-column flex-md-row"
                    style={{ gap: "10px" }}
                  >
                    <primaryComponents.DateInputV2
                      control={control}
                      name="start_date"
                      isRequired
                      label={"Delivery Date"}
                      value={formData?.start_date}
                      onChange={({ target: { value } }) => {
                        setFormData((prev) => ({
                          ...prev,
                          start_date: value,
                        }));
                      }}
                      errorMessage={errors?.start_date}
                      onKeyUp={() =>
                        errors?.start_date && trigger("start_date")
                      }
                    />

                    <primaryComponents.TimeInputV2
                      control={control}
                      name="time"
                      isRequired
                      value={formData?.time}
                      label={"Delivery Time"}
                      onChange={({ target: { value } }) => {
                        setFormData((prev) => ({
                          ...prev,
                          time: value,
                        }));
                      }}
                      errorMessage={errors?.time}
                      onKeyUp={() => errors?.time && trigger("time")}
                    />
                  </div>

                  <div className={"d-flex flex-row align-items-center"}>
                    <span className="d-block mr-4">Send Recurrently?</span>
                    <div
                      className="d-flex align-items-center"
                      style={{ gap: "12px" }}
                    >
                      <primaryComponents.RadioButton
                        name="sendRecurrently"
                        id={"sendRecurrentlyYes"}
                        value={"RECURRING"}
                        checked={formData?.delivery_type === "RECURRING"}
                        setRadioValue={() => {
                          setFormData((prev) => ({
                            ...prev,
                            delivery_type: "RECURRING",
                            frequency: "DAILY",
                          }));
                        }}
                      >
                        <span>Yes</span>
                      </primaryComponents.RadioButton>

                      <div
                        style={{
                          width: "2px",
                          height: "20px",
                          backgroundColor: "#ccc",
                        }}
                      ></div>

                      <primaryComponents.RadioButton
                        name="sendRecurrently"
                        id={"sendRecurrentlyNo"}
                        value={"SCHEDULED_ONCE"}
                        checked={formData?.delivery_type === "SCHEDULED_ONCE"}
                        setRadioValue={() => {
                          setFormData((prev) => ({
                            ...prev,
                            delivery_type: "SCHEDULED_ONCE",
                            days: [],
                            end_date: "",
                            frequency: "ONE_TIME",
                          }));
                        }}
                      >
                        <span>No</span>
                      </primaryComponents.RadioButton>
                    </div>
                  </div>

                  {formData?.delivery_type === "RECURRING" ? (
                    <div
                      className={`${globalStyles.cardWithBackground} mt-4`}
                      style={{ gap: "30px" }}
                    >
                      <div>
                        <span className="d-block mb-2">Frequency</span>
                        <div
                          className="d-flex align-items-center"
                          style={{ gap: "15px" }}
                        >
                          {/* <primaryComponents.RadioButton
                            name="frequency"
                            id={"frequencyOnce"}
                            value={true}
                            checked={formData?.frequency === "ONE_TIME"}
                            setRadioValue={() => {
                              setFormData((prev) => ({
                                ...prev,
                                frequency: "ONE_TIME",
                              }));
                            }}
                          >
                            <span>Once</span>
                          </primaryComponents.RadioButton> */}

                          <primaryComponents.RadioButton
                            name="frequency"
                            id={"frequencyDaily"}
                            value={false}
                            checked={formData?.frequency === "DAILY"}
                            setRadioValue={() => {
                              setFormData((prev) => ({
                                ...prev,
                                frequency: "DAILY",
                              }));
                            }}
                          >
                            <span>Daily</span>
                          </primaryComponents.RadioButton>

                          <primaryComponents.RadioButton
                            name="frequency"
                            id={"frequencyWeekly"}
                            value={false}
                            checked={formData?.frequency === "WEEKLY"}
                            setRadioValue={() => {
                              setFormData((prev) => ({
                                ...prev,
                                frequency: "WEEKLY",
                              }));
                            }}
                          >
                            <span>Weekly</span>
                          </primaryComponents.RadioButton>

                          <primaryComponents.RadioButton
                            name="frequency"
                            id={"frequencyMonthly"}
                            value={false}
                            checked={formData?.frequency === "MONTHLY"}
                            setRadioValue={() => {
                              setFormData((prev) => ({
                                ...prev,
                                frequency: "MONTHLY",
                              }));
                            }}
                          >
                            <span>Monthly</span>
                          </primaryComponents.RadioButton>
                        </div>
                      </div>

                      <div
                        className={`${globalStyles.cardWithBorder} white`}
                        style={{ gap: "20px" }}
                      >
                        <p className="dark--text">Select Day</p>
                        <div className={styles.daysCover}>
                          {days?.map((day, index) => (
                            <span
                              key={index}
                              className={`${globalStyles.statusBlock} ${styles.daysCover__item}`}
                            >
                              <label
                                className="cursor-pointer"
                                htmlFor={`dayOfWeek${index}`}
                              >
                                {capitalizeLetter(day)}
                              </label>
                              <primaryComponents.Checkbox
                                className="mb-1"
                                name="dayOfWeek"
                                id={`dayOfWeek${index}`}
                                isChecked={formData?.days.includes(day)}
                                onChange={() => {
                                  const dayOfWeek = formData.days;

                                  if (dayOfWeek.includes(day)) {
                                    const position = dayOfWeek.indexOf(day);
                                    dayOfWeek.splice(position, 1);
                                  } else dayOfWeek.push(day);

                                  setFormData((prevState) => ({
                                    ...prevState,
                                    days: dayOfWeek,
                                  }));
                                }}
                              />
                            </span>
                          ))}
                        </div>
                      </div>

                      <primaryComponents.DateInputV2
                        control={control}
                        name="end_date"
                        label={"End Date"}
                        value={formData?.end_date}
                        onChange={({ target: { value } }) => {
                          setFormData((prev) => ({
                            ...prev,
                            end_date: value,
                          }));
                        }}
                        errorMessage={errors?.end_date}
                        onKeyUp={() => errors?.end_date && trigger("end_date")}
                      />
                    </div>
                  ) : null}
                </>
              ) : null}
            </div>
          </primaryComponents.BoxedRadioInput>
        </div>

        <primaryComponents.Button
          classNames={"btn btn--primary ml-auto"}
          isDisabled={isSubmiting}
          isLoading={isSubmiting}
          loadingText={"Processing..."}
          onClick={handleSubmit(handleSubmitSchedule)}
        >
          Next: Review <ArrowRight className="ml-1" />
        </primaryComponents.Button>
      </div>
    </>
  );
};
